import React from 'react';
import styled from 'styled-components';
import CmsPopup from '../../../components/CmsPopup';
import { CmsPopupBtnType } from '../../../components/CmsPopupBtn';
import { AppTextField } from '../../../customComponents/AppTextField';
import dayjs from 'dayjs';

// 유저 상세 데이터 타입
export interface UserDetailData {
  no: number;
  index: number;
  name: string | null;
  email: string | null;
  locationType: 'DOMESTIC' | 'INTERNATIONAL';
  cellphone: string;
  createAt: string;
  updateAt: string;
  providerType: string | null;
  providerId: string | null;
  lastLoginAt: string | null; // API에서 lastLoginAt으로 오므로 변경
}

interface UserDetailPopupProps {
  isOpen: boolean;
  userData: UserDetailData | null;
  onClose: () => void;
}

// Styled Components
const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
`;

const UserDetailPopup: React.FC<UserDetailPopupProps> = ({
  isOpen,
  userData,
  onClose,
}) => {
  // 국가 타입 포맷팅 함수
  const formatLocationType = (locationType: 'DOMESTIC' | 'INTERNATIONAL') => {
    return locationType === 'DOMESTIC' ? '국내' : '국외';
  };

  // 로그인 계정 타입 포맷팅 함수
  const formatProviderType = (providerType: string | null) => {
    if (!providerType) return '일반';
    
    switch (providerType.toUpperCase()) {
      case 'KAKAO':
        return '카카오';
      case 'NAVER':
        return '네이버';
      case 'GOOGLE':
        return '구글';
      case 'APPLE':
        return '애플';
      default:
        return providerType;
    }
  };

  // 날짜 포맷팅 함수
  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    return dayjs(dateString).format('YYYY.MM.DD HH:mm:ss');
  };

  const renderForm = () => (
    <FormContainer>
      <AppTextField
        value={userData?.no?.toString() || ''}
        onChange={() => {}} // readonly이므로 빈 함수
        label="번호"
        readOnly
      />

      <AppTextField
        value={userData?.name || '-'}
        onChange={() => {}} // readonly이므로 빈 함수
        label="이름"
        readOnly
      />

      <AppTextField
        value={userData?.email || '-'}
        onChange={() => {}} // readonly이므로 빈 함수
        label="이메일"
        readOnly
      />

      <AppTextField
        value={userData?.cellphone || '-'}
        onChange={() => {}} // readonly이므로 빈 함수
        label="전화번호"
        readOnly
      />

      <AppTextField
        value={formatLocationType(userData?.locationType || 'DOMESTIC')}
        onChange={() => {}} // readonly이므로 빈 함수
        label="국가"
        readOnly
      />

      <AppTextField
        value={formatProviderType(userData?.providerType || null)}
        onChange={() => {}} // readonly이므로 빈 함수
        label="로그인 계정"
        readOnly
      />

      <AppTextField
        value={userData?.providerId || '-'}
        onChange={() => {}} // readonly이므로 빈 함수
        label="로그인 아이디"
        readOnly
      />

      <AppTextField
        value={formatDate(userData?.createAt || null)}
        onChange={() => {}} // readonly이므로 빈 함수
        label="가입일"
        readOnly
      />

      <AppTextField
        value={formatDate(userData?.updateAt || null)}
        onChange={() => {}} // readonly이므로 빈 함수
        label="정보 수정일"
        readOnly
      />

      <AppTextField
        value={formatDate(userData?.lastLoginAt || null)}
        onChange={() => {}} // readonly이므로 빈 함수
        label="최근 접속일"
        readOnly
      />
    </FormContainer>
  );

  return (
    <CmsPopup
      title="유저 상세 정보"
      isOpen={isOpen}
      onClose={onClose}
      width={"600px"}
      // isWide={false}
      showRequiredMark={false}
      leftButtons={[]}
      rightButtons={[
        {
          label: '닫기',
          onClick: onClose,
          type: CmsPopupBtnType.SECONDARY,
        },
      ]}
    >
      {renderForm()}
    </CmsPopup>
  );
};

export default UserDetailPopup;
